import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import BaseballTracker from './tracker';
import SportsTeamLogo from 'components/teamLogo';
import style from './style.module.scss';
import oddsStyle from './record/style.module.scss';
import BaseballViewRecord from './record';
import BaseballViewRegular from './regular';
import TextLengthTooltip from 'components/textLengthTooltip';
import { observer } from 'mobx-react';
import { useHistory } from 'react-router-dom';
import useStore from '../../../../hooks/useStore';
import Banner from '../../../../components/banner';
import { _SPORTS_TYPE } from '../../../../common/constants/sportsConstants';
import { getStreamBrowser } from '../../liveStream/util';

const BaseballView = observer(({ item, isSelected, setSelectedGame, isPopup, isAdmin, openCaster }) => {
  const { oddsData, venueName, period, sortedHomeScores, sortedAwayScores } = item;
  const [inningArr, setInningArr] = useState([1, 2, 3, 4, 5, 6, 7, 8, 9]);
  const [isOverView, setOverView] = useState(false);
  const [overPeriod, setOverPeriod] = useState(0);
  const homeTotalScore = sortedHomeScores.reduce((a, b) => a + b.score, 0);
  const awayTotalScore = sortedAwayScores.reduce((a, b) => a + b.score, 0);
  const history = useHistory();
  const { bannerStore } = useStore();

  useEffect(() => {
    if (!bannerStore.activeMajorViewId || bannerStore.activeMajorViewId === 'placeholder') {
      if (Number.isInteger(item.id)) {
        bannerStore.setActiveMajorView(item.id, _SPORTS_TYPE.BASEBALL);
      }
    }
  }, [bannerStore, bannerStore.activeMajorViewId, item.id]);

  useEffect(() => {
    if (period > 9) {
      const arr = new Array(period).fill(1).map((item, idx) => item * (idx + 1));

      setInningArr(arr);
      setOverView(true);
      setOverPeriod(period - 9);
    } else {
      setInningArr([1, 2, 3, 4, 5, 6, 7, 8, 9]);
      setOverView(false);
      setOverPeriod(0);
    }
  }, [period]);

  const onClickBetble = () => {
    let type = 0;

    if (item.getTracker.status === 'progress') {
      type = 1;
    }

    const url = `https://betble.com/game/game.php?type=${type}${item.betbleUri}`;

    window.open(url);
  };

  const onClickPrev = () => {
    setOverPeriod(0);
  };

  const onClickNext = () => {
    setOverPeriod(period - 9);
  };

  // const onClickVideo = () => {
  //   window.open(
  //     item.videoLink,
  //     `live_${item.id}`,
  //     "width=980px,height=750px,scrollbars=yes"
  //   );
  // };
  const onClickVideo = () => {
    getStreamBrowser(item.videoLink);
  };

  const setSelectedItem = () => {
    setSelectedGame(isSelected, item.id, item.startDatetime, item.gameStatus, 'baseball');
  };

  const onClickData = () => {
    window.open(`/match/baseball/${item.id}?20210308`, `detail_${item.id}`, 'width=1000px,height=901px,scrollbars=yes');
  };

  return (
    <>
      <div className={style.score_board}>
        {/* tracker  */}
        <BaseballTracker item={item} tracker={item.getTracker} typeData={item.getTypeData} isPopup={isPopup} />
        {/*// tracker  */}

        {/* summary_score  */}
        <div className={style.summary_score}>
          <div className={style.info}>
            <span className={style.league}>{item.league.shortName}</span>
            <span className={style.time}>{item.getStartDateTime}</span>
            <span className={clsx(style.state, item.getTracker.status === 'progress' && style.on)}>
              {item.statusText}
            </span>
          </div>
          <div className={style.team_area}>
            <div className={clsx(style.team, style.away)}>
              <SportsTeamLogo imgSize={'55'} imgUrl={!!item.teams ? item.teams.away.imgPath : null} isLazy={true} />
              <div className={style.name}>{item.getTeamData.away.name}</div>
              {item.gameStatus === 'READY' ? (
                item.getBaseballPlayer.away.isHaveData && (
                  <div className={style.aa}>
                    <em>선발</em>
                    <TextLengthTooltip
                      name={item.getBaseballPlayer.away.player}
                      className={style.player}
                      maxLength={7}
                    />
                  </div>
                )
              ) : (
                <div
                  className={clsx(style.point, item.getTeamData.home.score < item.getTeamData.away.score && style.on)}
                >
                  {item.getTeamData.away.score}
                </div>
              )}
            </div>
            <div className={clsx(style.team, style.home)}>
              <SportsTeamLogo imgSize={'55'} imgUrl={!!item.teams ? item.teams.home.imgPath : null} isLazy={true} />
              <div className={style.name}>{item.getTeamData.home.name}</div>
              {item.gameStatus === 'READY' ? (
                item.getBaseballPlayer.home.isHaveData && (
                  <div className={style.aa}>
                    <em>선발</em>
                    <TextLengthTooltip
                      name={item.getBaseballPlayer.home.player}
                      className={style.player}
                      maxLength={7}
                    />
                  </div>
                )
              ) : (
                <div
                  className={clsx(style.point, item.getTeamData.home.score > item.getTeamData.away.score && style.on)}
                >
                  {item.getTeamData.home.score}
                </div>
              )}
            </div>
          </div>
          <div className={style.btn_area}>
            {!isPopup && (
              <>
                <button
                  className={clsx(style.btn, style.btn_arrow, isSelected ? style.down : style.up)}
                  onClick={setSelectedItem}
                >
                  올리기/내리기
                </button>
                {/*{item.betbleButtonVisible && (*/}
                {/*  <button className={clsx(style.btn, style.betting)} onClick={onClickBetble}>*/}
                {/*    베팅*/}
                {/*  </button>*/}
                {/*)}*/}

                <button className={clsx(style.btn, style.btn_lineup)} onClick={onClickData}>
                  상세보기
                </button>
                {!!item.videoLink &&
                  (item.gameStatus === 'IN_PROGRESS' ||
                    item.gameStatus === 'BREAK_TIME' ||
                    item.gameStatus === 'PAUSE') && (
                    <button className={clsx(style.btn, style.btn_live)} onClick={onClickVideo}>
                      생중계
                    </button>
                  )}
                {isAdmin && (
                  <button className={clsx(style.btn, style.btn_admin)} onClick={() => openCaster(2, item.id)}>
                    AD
                  </button>
                )}
              </>
            )}
          </div>
        </div>
        {/*// summary_score  */}

        {/* detail_score  */}
        <div className={style.detail_score}>
          <div className={clsx(style.board, isOverView && style.overtime, style[item.getTracker.class])}>
            {item.getTracker.status === 'ready' ? (
              <BaseballViewRecord home={item.teams.home} away={item.teams.away} />
            ) : (
              <BaseballViewRegular
                overPeriod={overPeriod}
                inningArr={inningArr}
                special={item.special}
                tracker={item.getTracker}
                period={period}
                sortedAwayScores={sortedAwayScores}
                sortedHomeScores={sortedHomeScores}
                isOverView={isOverView}
                onClickPrev={onClickPrev}
                onClickNext={onClickNext}
                awayTotalScore={awayTotalScore}
                homeTotalScore={homeTotalScore}
                home={item.teams.home}
                away={item.teams.away}
              />
            )}
            <dl className={clsx(oddsStyle.item, oddsStyle.odds)}>
              <dt>국내</dt>
              <dd>
                <span>{!!oddsData.domestic.away && oddsData.domestic.away}</span>
                <span>{!!oddsData.domestic.awayOption && oddsData.domestic.awayOption}</span>
              </dd>
              <dd>
                <span>{!!oddsData.domestic.home && oddsData.domestic.home}</span>
                <span>{!!oddsData.domestic.homeOption && oddsData.domestic.homeOption}</span>
              </dd>
            </dl>
            <dl className={clsx(oddsStyle.item, oddsStyle.odds)}>
              <dt>해외</dt>
              <dd>
                <span>{!!oddsData.international.away && oddsData.international.away}</span>
                <span>{!!oddsData.international.awayOption && oddsData.international.awayOption}</span>
              </dd>
              <dd>
                <span>{!!oddsData.international.home && oddsData.international.home}</span>
                <span>{!!oddsData.international.homeOption && oddsData.international.homeOption}</span>
              </dd>
            </dl>
          </div>
          <div className={style.stadium}>
            <span className={style.tx}>{venueName}</span>
          </div>
        </div>
        {/*// detail_score  */}
      </div>
      {bannerStore.activeMajorViewId === item.id ? <Banner paddingTop='10px' paddingBottom='0' /> : null}
    </>
  );
});

export default BaseballView;
